import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {AuthenticationService} from '../../services/authentication.service';
import {ValidateService} from '../../services/validate.service';

declare var jquery:any;
declare var $ :any;

import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})
export class AccountsComponent implements OnInit {
  user:Object;
  accounts:Accounts[];
  meetingrooms:MeetingRooms[];
  workgroups:WorkGroups[];
  public submitted:boolean;
  constructor(private validateService:ValidateService, private authService:AuthenticationService,  private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) { }

  ngOnInit() {
    this.refreshEverything();
  }
  refreshEverything = ()=>{


      this.getdataService.getAccounts().subscribe((accounts) => {
        this.accounts=  accounts;
        
        //for(let i=0)

      },
    err=>{
      //////console.log(err);
      return false;
    });
    

  }

  addAccount =function () {
    this.submitted=true;
    let accoutnname = this.elem.nativeElement.querySelector('#accoutnname').value;
    let number_of_rooms_for_this_account = this.elem.nativeElement.querySelector('#number_of_rooms_for_this_account').value;
    let feature_outlook =  this.elem.nativeElement.querySelector("#features_checkboxes_outlook").checked ;
    let feature_google_calendar =  this.elem.nativeElement.querySelector("#features_checkboxes_googlecalendar").checked ;
    let feature_client_portal =  this.elem.nativeElement.querySelector("#features_checkboxes_portal").checked ;

    //console.log(feature_outlook)
    const account = {
      account_name: accoutnname,
      licensed_rooms: number_of_rooms_for_this_account,
      feature_outlook: feature_outlook,
      feature_google_calendar: feature_google_calendar,
      feature_client_portal: feature_client_portal
    }
    ////console.log("this could be a duplicate?");


          ////console.log("no duplicate");
          this.adddataService.addAccount(account).subscribe(data =>{

              alert('Account Added');
                this.submitted=false;

          });



        this.refreshEverything();

    }



  deleteUser = function(userID,userEmail) {
         if(confirm('Are you sure you want to delete "'+userEmail+'"?')) {
         this.submitted=true;
         this.deletedataService.deleteUser(userID).subscribe((res:Response)=>{
               ////////refresh category /////////////
               this.refreshEverything();
             //////////end refresh category.////////
              this.submitted=false;
       });
    }
  }

   updateTextArea = function() {

  }

}
interface Accounts{
  _id:number,
  account_name:string,
  licensed_rooms:number
}

interface MeetingRooms{
  _id:number,
  room_name:string,
  room_place:string,
  room_default_logo:string,
  room_default_logo_path:string,
  room_type:string,
  room_floor_number:string,
  room_slider_ID:string
}

interface WorkGroups{
  _id:number,
  account_ID:string,
  workgroup_name:string
}



// WEBPACK FOOTER //
// ./src/app/components/accounts/accounts.component.ts